export default __webpack_public_path__ + "static/media/Desktop-Accessories.027ada94.jpg";